var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCats = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.95 10.938c-.1-.7.4-2.8.4-2.8 0-1-.8-.3-.8-.3l-1.3 1.7c-.4-.2-.8-.3-1.3-.3s-1.1.1-1.6.2l-1.3-1.7s-.8-.7-.8.3c0 0 .4 1.9.4 2.7-.4.9.1 2.1.3 3 0 0-3.2 2.1-5 3.7-1.3 1.2-3.4 3.8-3.4 7 0 0 0 3.1.1 4 0 0-.6 2.5.6 3.6 1.2 1.2 3.7 2.6 8.3-.6 0 0 .2-.5-.7-.2s-6.1 2.1-5.9-1.7h7.8s.5-.2.2-1c-.1-.4-.3-.4-.8-.4h-.8l1.8-1.9 1.1 2s.6 1.2.8 1.3c.2.2 1 .2 1.3 0s.5-1 .4-1.3c-.2-.3-.8-.4-.8-.4l-1.1-6.2s2.1-3.3 1.6-7.3c-.1-.1 1.3-1.6.5-3.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.15 11.838c0 .2-.4.4-.7.4s-.6-.4-.6-.6.4-.4.7-.4c.4 0 .6.4.6.6ZM24.55 11.838c0 .2.4.4.7.4s.6-.4.6-.6-.4-.4-.7-.4c-.4 0-.6.4-.6.6ZM18.15 20.138s4.3.4 5 6.1"
}))));
export default SvgCats;